import React from 'react';

/**
 * Children / slots for shell layout. Using `JSX.Element` because `react-app-env.d.ts`
 * stubs `declare module 'react'`, so `ReactNode` / `React.ReactElement` are not usable as types.
 */
type ShellSlot = JSX.Element | string | number | boolean | null | undefined;

/** Full-viewport shell background + typography (firm + client portals). */
export function AppShell({ children }: { children: ShellSlot | ShellSlot[] }) {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-[var(--app-shell-bg)] font-sans text-[var(--ink)]">
      {children}
    </div>
  );
}

/** Top row: logo strip + main header column (shared by firm and client layouts). */
export function AppShellTopRow({ logo, header }: { logo: ShellSlot; header: ShellSlot }) {
  return (
    <div className="flex shrink-0 items-stretch border-b border-gray-200">
      {logo}
      <div className="flex min-w-0 flex-1 flex-col bg-white">{header}</div>
    </div>
  );
}

/** Sidebar + main content (typically `<Outlet />`). */
export function AppShellBody({ sidebar, children }: { sidebar: ShellSlot; children: ShellSlot }) {
  return (
    <div className="flex min-h-0 flex-1">
      {sidebar}
      {children}
    </div>
  );
}
